const _excluded = ["label"],
  _excluded2 = ["label"],
  _excluded3 = ["hint", "error"],
  _excluded4 = ["hint", "label"],
  _excluded5 = ["className", "children", "onSubmit", "acceptCharset"],
  _excluded6 = ["label", "hint", "checked"],
  _excluded7 = ["label", "hint", "items"];
var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/forms/index.tsx";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import classNames from 'classnames';
import React, { useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import { Text, Select } from '../../components/ui';
export const InputContainer = props => {
  const containerClass = classNames('input', {
    'with_label': props.label,
    'required': props.required,
    'boolean': props.type === 'checkbox',
    'field_with_errors': props.error
  }, props.extraClass);
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, props.children, props.hint && /*#__PURE__*/React.createElement("span", {
    className: "hint",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 22
    }
  }, props.hint));
};
export const LabelInputContainer = ({
  label,
  hint,
  children
}) => {
  const [id] = useState(uuidv4());
  const childrenWithProps = React.Children.map(children, child => (
  /*#__PURE__*/
  // @ts-ignore: not sure how to get the right type here
  React.cloneElement(child, {
    id: id,
    key: id
  })));
  return /*#__PURE__*/React.createElement("div", {
    className: "label_input",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 7
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "label_input__wrapper",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 7
    }
  }, childrenWithProps), hint && /*#__PURE__*/React.createElement("span", {
    className: "hint",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 16
    }
  }, hint));
};
export const LabelInput = _ref => {
  let {
      label
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(LabelInputContainer, {
    label: label,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("input", _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 5
    }
  })));
};
export const LabelTextarea = _ref2 => {
  let {
      label
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(LabelInputContainer, {
    label: label,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("textarea", _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 5
    }
  })));
};
export const SimpleInput = props => {
  const {
      hint,
      error
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  const Input = props.label ? LabelInput : 'input';
  return /*#__PURE__*/React.createElement(InputContainer, _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Input, _extends({}, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 7
    }
  })));
};
export const SimpleTextarea = props => {
  const {
      hint,
      label
    } = props,
    rest = _objectWithoutProperties(props, _excluded4);
  const Input = label ? LabelTextarea : 'textarea';
  return /*#__PURE__*/React.createElement(InputContainer, _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Input, _extends({}, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 7
    }
  })));
};
export const SimpleForm = props => {
  const {
      className,
      children,
      onSubmit = () => {},
      acceptCharset = 'UTF-8'
    } = props,
    rest = _objectWithoutProperties(props, _excluded5);
  const handleSubmit = e => {
    onSubmit(e);
    e.preventDefault();
  };
  return /*#__PURE__*/React.createElement("form", _extends({
    className: classNames('simple_form', className),
    method: "post",
    onSubmit: handleSubmit,
    acceptCharset: acceptCharset
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 5
    }
  }), children);
};
export const FieldsGroup = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "fields-group",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 162,
    columnNumber: 3
  }
}, children);
export const Checkbox = props => /*#__PURE__*/React.createElement(SimpleInput, _extends({
  type: "checkbox"
}, props, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 176,
    columnNumber: 3
  }
}));
export const RadioGroup = props => {
  const {
    label,
    children,
    onChange
  } = props;
  const childrenWithProps = React.Children.map(children, child =>
  /*#__PURE__*/
  // @ts-ignore
  React.cloneElement(child, {
    onChange
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "input with_floating_label radio_buttons",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 193,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "label_input",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 194,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("label", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 195,
      columnNumber: 9
    }
  }, label), /*#__PURE__*/React.createElement("ul", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 196,
      columnNumber: 9
    }
  }, childrenWithProps)));
};
export const RadioItem = props => {
  const {
    current: id
  } = useRef(uuidv4());
  const {
      label,
      hint,
      checked = false
    } = props,
    rest = _objectWithoutProperties(props, _excluded6);
  return /*#__PURE__*/React.createElement("li", {
    className: "radio",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 215,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 216,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    type: "radio",
    checked: checked
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 217,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Text, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 218,
      columnNumber: 9
    }
  }, label), hint && /*#__PURE__*/React.createElement("span", {
    className: "hint",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 219,
      columnNumber: 18
    }
  }, hint)));
};
export const SelectDropdown = props => {
  const {
      label,
      hint,
      items
    } = props,
    rest = _objectWithoutProperties(props, _excluded7);
  const optionElems = Object.keys(items).map(item => /*#__PURE__*/React.createElement("option", {
    key: item,
    value: item,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 237,
      columnNumber: 5
    }
  }, items[item]));

  // @ts-ignore
  const selectElem = /*#__PURE__*/React.createElement(Select, _extends({}, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 241,
      columnNumber: 22
    }
  }), optionElems);
  return label ? /*#__PURE__*/React.createElement(LabelInputContainer, {
    label: label,
    hint: hint,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 244,
      columnNumber: 5
    }
  }, selectElem) : selectElem;
};
export const TextInput = props => /*#__PURE__*/React.createElement(SimpleInput, _extends({
  type: "text"
}, props, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 264,
    columnNumber: 3
  }
}));
export const FileChooser = props => /*#__PURE__*/React.createElement(SimpleInput, _extends({
  type: "file"
}, props, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 268,
    columnNumber: 3
  }
}));
FileChooser.defaultProps = {
  accept: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
};
export const FileChooserLogo = props => /*#__PURE__*/React.createElement(SimpleInput, _extends({
  type: "file"
}, props, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 284,
    columnNumber: 3
  }
}));
FileChooserLogo.defaultProps = {
  accept: ['image/svg', 'image/png']
};
export const CopyableInput = ({
  value
}) => {
  const node = useRef(null);
  const handleCopyClick = () => {
    if (!node.current) return;
    node.current.select();
    node.current.setSelectionRange(0, 99999);
    document.execCommand('copy');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "copyable-input",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 308,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("input", {
    ref: node,
    type: "text",
    value: value,
    readOnly: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 309,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: "p-2 text-white bg-primary-600",
    onClick: handleCopyClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 310,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "forms.copy",
    defaultMessage: "Copy",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 311,
      columnNumber: 9
    }
  })));
};